import { Model, useRepo } from 'pinia-orm';
import { normalizeJson } from "../../shared/helpers";
import { useCommonStore } from "../../shared/state/common";

export default class AnalyticsPreset extends Model {
    static get entity() {
        return 'analytics-presets'
    }

    static fields() {
        return {
            id: this.uid(),
            name: this.attr(''),
            filters: this.attr({}),
        }
    }

    static fetch() {
        const commonStore = useCommonStore();
        const companyId = commonStore.currentCompanyId;
        return axios.get(route('api.manage.companies.analytics-presets', { company: companyId }))
            .then(({ data }) => useRepo(AnalyticsPreset).save(normalizeJson(data.data)));
    }

    static dbStore(data) {
        const commonStore = useCommonStore();
        const companyId = commonStore.currentCompanyId;
        return axios.post(route('api.manage.companies.analytics-presets.store', { company: companyId }), data)
            .then(({ data }) => useRepo(AnalyticsPreset).save(normalizeJson(data)));
    }

    static dbDelete(id) {
        const commonStore = useCommonStore();
        const companyId = commonStore.currentCompanyId;
        return axios.delete(route('api.manage.companies.analytics-presets.delete', { company: companyId, analyticsPreset: id }));
    }
}
